import React, { useState, useEffect } from 'react';
import { getQueueCount } from '../../lib/diktat-offline-db';
import { syncQueue } from '../../lib/diktat-sync';
import { MIcon } from '../../lib/micon';

export function OfflineQueueIndicator() {
  const [count,   setCount]   = useState(0);
  const [syncing, setSyncing] = useState(false);

  async function refresh() {
    try { setCount(await getQueueCount()); } catch { /* IndexedDB nicht verfügbar */ }
  }

  useEffect(() => {
    refresh();
    const iv = setInterval(refresh, 10_000);
    return () => clearInterval(iv);
  }, []);

  if (count === 0) return null;

  async function handleSync() {
    setSyncing(true);
    try { await syncQueue(); } finally {
      setSyncing(false);
      refresh();
    }
  }

  return (
    <button
      onClick={handleSync}
      disabled={syncing || !navigator.onLine}
      title={navigator.onLine ? 'Jetzt synchronisieren' : 'Offline — wird hochgeladen sobald online'}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 5,
        padding: '5px 10px', borderRadius: 'var(--ld-radius-pill)',
        border: 'none', cursor: navigator.onLine ? 'pointer' : 'default',
        background: navigator.onLine ? '#FEF3C7' : '#F3F4F6',
        color: navigator.onLine ? '#92400E' : '#6B7280',
        fontSize: 12, fontWeight: 600,
        opacity: syncing ? 0.7 : 1,
        whiteSpace: 'nowrap' as const,
      }}
    >
      <span style={{ animation: syncing ? 'udSpin 0.8s linear infinite' : 'none', display: 'inline-block' }}>
        <MIcon name="sync" size={16} />
      </span>
      {syncing ? 'Lädt hoch…' : `${count} ${count === 1 ? 'Diktat' : 'Diktate'} warten`}
    </button>
  );
}
